import React from "react";
import { WordRestrictions } from "../../../models/extension/WordExtention";
import { BookletType } from "../../../models/interfaces/education/BookletType";
import BookletsService from "../../../services/education/BookletsService";
import NotFoundDataInDate from "../../shared/not-found-data-in-date/NotFoundDataInDate";
import EducationalBookletModal from "../educational-booklet-modal/EducationalBookletModal";
import './EducationalBooklet.scss';
import EducationalBookletState, { bookletFilters, EducationalBookletProps } from "./EducationalBooklet.models";
import EducationalBookletFilterModal from "../educational-booklet-filter-modal/EducationalBookletFilterModal";
import { TableData } from "../../../models/dtos/base/TableData";
import { BookLetsEditionView } from "../../../models/views/education/BookLetsEditionView";
import CoachingImg from "../../../assest/images/card-image/coaching-img.png";
import { NavLink } from "react-router-dom";

export default class EducationalBooklet extends React.PureComponent<EducationalBookletProps, EducationalBookletState> {
    bookletsService: BookletsService;
    constructor(props: any) {
        super(props);
        this.bookletsService = new BookletsService();
        this.state = {
            booklets: {
                rows: [],
                totalRowCount: 0
            },
            showModal: false,
            selectedId: undefined,
            showFilterModal: false,
            filters: { showBookMarks: false }
        };
    }

    componentDidMount() {
        let self = this;
        self.getPage();
    }

    getPage = () => {
        let self = this;
        self.bookletsService.getMyCoachings().then(function (response) {
            self.setState({ booklets: {rows: response, totalRowCount: response.length} });
        });
    }

    getpageBookMarks = () => {
        let self = this;
        self.bookletsService.getBookMark().then(function (response) {
            response = response ?? [];
            self.setState({ booklets: { rows: response, totalRowCount: response.length } });
        });
    }

    closeModal = () => {
        this.setState({ showModal: false });
    }

    showModal = (id?: number) => {
        if (id !== undefined && id !== null)
            this.setState({ showModal: true, selectedId: id });
    }

    handleFilter = (name?: string, fileType?: BookletType) => {
        this.setState({ filters: { name: name, fileType: fileType, showBookMarks: this.state.filters.showBookMarks }, showFilterModal: false });
        this.forceUpdate();
    }

    openFilter = (e: any) => {
        this.setState({ showFilterModal: true })
        this.removeProgress(e);
    }

    removeFilter = (e: any) => {
        this.setState({ filters: { name: undefined, fileType: undefined, showBookMarks: false } });
        this.getPage();
        this.removeProgress(e);
    }

    removeProgress = (e: any) => {
        e.stopPropagation();
    }

    handleShowBook = () => {
        let bookMark = this.state.filters;

        if (!bookMark.showBookMarks) {
            this.getpageBookMarks();
        } else {
            this.getPage();
        }

        this.setState({ filters: { name: bookMark.name, fileType: bookMark.fileType, showBookMarks: !bookMark.showBookMarks }, showFilterModal: false });

        this.forceUpdate();
    }

    render(): React.ReactNode {
        let { booklets, filters } = this.state;
        let content;
        if (booklets.rows.length > 0)
            content = (<>
                {this.bookletsView(booklets, filters)}
            </>);
        else
            content = (
                <NotFoundDataInDate title="موردی یافت نشد" />
            );

        return (<>
            {this.filterAreaView(filters)}
            <div className="dropdown-list education-booklet-area" style={{ height: "80vh" }}>
                {content}
            </div>
            <EducationalBookletModal closeModal={this.closeModal} showModal={this.state.showModal} id={this.state.selectedId} />
            <EducationalBookletFilterModal handleSearch={this.handleFilter} closeModal={() => this.setState({ showFilterModal: false })}
                showModal={this.state.showFilterModal} showBookMarks={filters.showBookMarks} handleBookMark={this.handleShowBook} />
        </>);
    }

    filterAreaView(filters: bookletFilters) {
        return <>
            <div className="education-booklet-area filter-area">
                {(filters.name !== null && filters.name !== undefined) || (filters.fileType !== null && filters.fileType !== undefined) || (filters.showBookMarks === true) ?
                    <label className="mdi mdi-filter-remove" onClick={(e) => this.removeFilter(e)}></label>
                    : <></>
                }
                <label className="mdi mdi-filter mr-2" onClick={(e) => this.openFilter(e)}></label>
            </div>
        </>
    }

    bookletCardView = (icon: any, lock: boolean, fileAttachmentId?: string | null, imageAttachment?: string | null) => {
        return <div className="coaching-card">
            <div style={{ margin: 0 }} className="d-flex justify-content-between head">
                {!lock ?
                    <label className="coaching-badge text-center">
                        رایگان
                    </label> :
                    <label className="coaching-badge text-center">
                        <span className="mdi mdi-lock"></span>
                    </label>
                }
                {icon}
            </div>
            {
                // fileAttachmentId != null && <video>
                //     <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${fileAttachmentId}`} type="video/webm" />
                //     <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${fileAttachmentId}`} type="video/ogg" />
                //     <source src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${fileAttachmentId}`} type="video/mp4" />
                // </video>
                imageAttachment != null &&
                <img className="thumbnail" src={`https://cdn.barandehsaz.com/FileUploader/Download/?AttachmentID=${imageAttachment}`} />
            }
        </div>
    }

    bookletsView(booklets: TableData<BookLetsEditionView>, filter: bookletFilters) {
        return <div className="d-flex flex-wrap">
            {booklets.rows.filter(item => {
                let nameFilter = true;
                let typeFilter = true;
                if ((item.authorFullName !== undefined && item.authorFullName !== null) && (filter.name !== undefined && filter.name !== null))
                    nameFilter = item.authorFullName.includes(filter.name)

                if ((filter.fileType !== undefined && filter.fileType !== null)) {
                    var searchItem = filter.fileType == 0 ? "" : filter.fileType == 1 ? "video" : filter.fileType == 2 ? "audio" : filter.fileType == 3 ? "image" : "application";
                    if ((item.fileContentType === null || item.fileContentType === undefined || item.fileContentType === "") && searchItem === "") {
                        typeFilter = true;
                    }
                    else
                        typeFilter = false;

                    if ((item.fileContentType !== null && item.fileContentType !== undefined) && item.fileContentType !== "" && searchItem !== "")
                        typeFilter = item.fileContentType != null ? item.fileContentType.includes(searchItem) : false;
                }

                return typeFilter && nameFilter;
            }).map((booklet, key) => {
                let icon;
                let fileSize;
                if (booklet.bookletType === BookletType.Written) {
                    icon = (<>
                        <div className="badge green-badge">
                            <label className="mdi mdi-book-open-variant"></label>
                        </div>
                    </>);
                }
                else if (booklet.bookletType === BookletType.File) {
                    icon = (<>
                        <img width={30} height={30} src={CoachingImg} />
                    </>);
                }
                else {
                    icon = (<></>);
                    fileSize = (<></>);
                }

                const className = "card-boundel inline-video";

                return <div key={key} className={`coaching-area margin-top ${booklet.lock ? " lock" : ""}`}>
                    <div className={className}>
                        {
                            !booklet.lock ?
                                <NavLink to={`/EducationalBooklet/Details?bookletId=${booklet.id}`}>
                                    {this.bookletCardView(icon, false, booklet.fileAttachmentId, booklet.imageAttachment)}
                                </NavLink> :
                                this.bookletCardView(icon, true, booklet.fileAttachmentId, booklet.imageAttachment)
                        }
                        <div className="bottom-shadow">
                            <label>
                                {booklet.title !== null && booklet.title !== undefined ? WordRestrictions(booklet.title, 20) : ""}
                            </label>
                        </div>
                    </div>
                </div>
            })}
        </div>
    }
}